module.exports = __webpack_public_path__ + "static/img/SmallProgram.2dc1c5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SmallProgram.png
// module id = 1Zsy
// module chunks = 5